/**
 * LeagueTabPlaceholders.js
 */
import { LeagueWSL }            from './LeagueWSL.js';
import { LeagueNWSL }           from './LeagueNWSL.js';
import { LeagueWE }             from './LeagueWE.js';
import { LeagueUSL }            from './LeagueUSL.js';
import { LeagueJLeague }        from './LeagueJLeague.js';
import { LeagueSAFem }          from './LeagueSAFem.js';
import { LeagueFrauenBL }       from './LeagueFrauenBL.js';
import { LeagueLigaF }          from './LeagueLigaF.js';
import { LeagueNWFL }           from './LeagueNWFL.js';
import { LeagueDamallsvenskan } from './LeagueDamallsvenskan.js';
import { LeagueArkema }         from './LeagueArkema.js';
import { LeagueLigaMXFem }      from './LeagueLigaMXFem.js';
import { LeagueBrasileiroFem }  from './LeagueBrasileiroFem.js';
import { LeagueALeagueWomen }   from './LeagueALeagueWomen.js';
import { LeagueSAFF }           from './LeagueSAFF.js';
import { LeagueWK }             from './LeagueWK.js';
import { LeagueToppserien } from './LeagueToppserien.js';
import { LeagueEredivisie } from './LeagueEredivisie.js';
import { LeagueOFB }        from './LeagueOFB.js';
import { LeagueNSL }         from './LeagueNSL.js';
import { LeagueBWSL }       from './LeagueBWSL.js';
import { LeagueBPI }            from './LeagueBPI.js';

const LEAGUE_MAP = {
    wsl:     { rootId: 'wsl-root',     Cls: LeagueWSL },
    nwsl:    { rootId: 'nwsl-root',    Cls: LeagueNWSL },
    we:      { rootId: 'we-root',      Cls: LeagueWE },
    usl:     { rootId: 'usl-root',     Cls: LeagueUSL },
    jleague: { rootId: 'jleague-root', Cls: LeagueJLeague },
    seriea:  { rootId: 'seriea-root',  Cls: LeagueSAFem },
    dfb:     { rootId: 'dfb-root',     Cls: LeagueFrauenBL },
    ligaf:   { rootId: 'ligaf-root',   Cls: LeagueLigaF },
    nwfl:    { rootId: 'nwfl-root',    Cls: LeagueNWFL },
    sweden:  { rootId: 'sweden-root',  Cls: LeagueDamallsvenskan },
    apl:     { rootId: 'apl-root',     Cls: LeagueArkema },
    ligamx:  { rootId: 'ligamx-root',  Cls: LeagueLigaMXFem },
    brasil:  { rootId: 'brasil-root',  Cls: LeagueBrasileiroFem },
    aleague: { rootId: 'aleague-root', Cls: LeagueALeagueWomen },
    saff:    { rootId: 'saff-root',    Cls: LeagueSAFF },
    wk:      { rootId: 'wk-root',      Cls: LeagueWK },
    toppserien: { rootId: 'toppserien-root', Cls: LeagueToppserien },
    eredivisie: { rootId: 'eredivisie-root', Cls: LeagueEredivisie },
    ofb:        { rootId: 'ofb-root',        Cls: LeagueOFB },
    bwsl:       { rootId: 'bwsl-root',       Cls: LeagueBWSL },
    bpi:     { rootId: 'bpi-root',     Cls: LeagueBPI },
};

export function renderLeagueTabPanel(tabId, league) {
    const entry = LEAGUE_MAP[league.id];
    if (entry) {
        scheduleMount(entry.rootId, entry.Cls);
        return '<div id="' + entry.rootId + '"></div>';
    }
    return '<div style="padding:48px 24px;text-align:center;color:var(--text-secondary,#888);font-size:13px;">' +
        '<div style="font-size:32px;margin-bottom:12px;opacity:.4;">\u26bd</div>' +
        '<p style="font-weight:600;font-size:15px;margin-bottom:6px;color:var(--text-color,#111);">' +
        league.title + '</p>' +
        '<p>Live data coming soon for this league.</p>' +
        '</div>';
}

function scheduleMount(rootId, ComponentClass) {
    Promise.resolve().then(() => {
        const el = document.getElementById(rootId);
        if (!el || el.dataset.mounted) return;
        el.dataset.mounted = 'true';
        const instance = new ComponentClass(rootId);
        instance.init();
    });
}
